__turbopack_context__.v({
  "addressBar": "GestaoModule-module__1teMwa__addressBar",
  "amountIn": "GestaoModule-module__1teMwa__amountIn",
  "amountOut": "GestaoModule-module__1teMwa__amountOut",
  "browserBar": "GestaoModule-module__1teMwa__browserBar",
  "chartBar": "GestaoModule-module__1teMwa__chartBar",
  "chartWrapper": "GestaoModule-module__1teMwa__chartWrapper",
  "dashboardBody": "GestaoModule-module__1teMwa__dashboardBody",
  "desktopMockup": "GestaoModule-module__1teMwa__desktopMockup",
  "dots": "GestaoModule-module__1teMwa__dots",
  "fadeInDown": "GestaoModule-module__1teMwa__fadeInDown",
  "fadeInRight": "GestaoModule-module__1teMwa__fadeInRight",
  "fiscalMockup": "GestaoModule-module__1teMwa__fiscalMockup",
  "fiscalStamp": "GestaoModule-module__1teMwa__fiscalStamp",
  "fiscalTitle": "GestaoModule-module__1teMwa__fiscalTitle",
  "green": "GestaoModule-module__1teMwa__green",
  "growUp": "GestaoModule-module__1teMwa__growUp",
  "iconIn": "GestaoModule-module__1teMwa__iconIn",
  "iconInv": "GestaoModule-module__1teMwa__iconInv",
  "iconOut": "GestaoModule-module__1teMwa__iconOut",
  "iconRec": "GestaoModule-module__1teMwa__iconRec",
  "listBody": "GestaoModule-module__1teMwa__listBody",
  "listContainer": "GestaoModule-module__1teMwa__listContainer",
  "listHeader": "GestaoModule-module__1teMwa__listHeader",
  "mockupContainer": "GestaoModule-module__1teMwa__mockupContainer",
  "popStamp": "GestaoModule-module__1teMwa__popStamp",
  "statCard": "GestaoModule-module__1teMwa__statCard",
  "statGreen": "GestaoModule-module__1teMwa__statGreen",
  "statRed": "GestaoModule-module__1teMwa__statRed",
  "statTitle": "GestaoModule-module__1teMwa__statTitle",
  "statValue": "GestaoModule-module__1teMwa__statValue",
  "statsRow": "GestaoModule-module__1teMwa__statsRow",
  "statusPaid": "GestaoModule-module__1teMwa__statusPaid",
  "statusPending": "GestaoModule-module__1teMwa__statusPending",
  "txAmount": "GestaoModule-module__1teMwa__txAmount",
  "txIcon": "GestaoModule-module__1teMwa__txIcon",
  "txInfo": "GestaoModule-module__1teMwa__txInfo",
  "txMeta": "GestaoModule-module__1teMwa__txMeta",
  "txName": "GestaoModule-module__1teMwa__txName",
  "txRight": "GestaoModule-module__1teMwa__txRight",
  "txRow": "GestaoModule-module__1teMwa__txRow",
  "txStatus": "GestaoModule-module__1teMwa__txStatus",
  "typeWriter": "GestaoModule-module__1teMwa__typeWriter",
  "xmlLine": "GestaoModule-module__1teMwa__xmlLine",
  "xmlTag": "GestaoModule-module__1teMwa__xmlTag",
  "xmlVal": "GestaoModule-module__1teMwa__xmlVal",
});
